module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/camera-bbeb94896106a7f2b8955c9c8156e163.svg";